import { WatchOff } from "@mui/icons-material";

type MissedWorkIconsProps = {
    hasMissingHours: boolean;
};

export const MissedWorkIcons = ({ hasMissingHours }: MissedWorkIconsProps) => {
    return (
        <>
            {hasMissingHours ? <WatchOff sx={{ ml: 1, verticalAlign: "middle" }} color="error" /> : null}
        </>
    );
};
